<template>
  <div>
    <div class="container-product-image">
      <div class="container">
        <div class="row">
          <div class="col-12 product-image">
            <img :src="require(`../assets/${mainProductImage}`)" />
          </div>
        </div>
      </div>
    </div>
    <div class="container blade-faq" :id="id">
      <div class="row">
        <div class="col-12">
          <div class="accordion" role="tablist">
            <icon-toggle-plus />
            <b-card
              v-for="(faq, index) in product"
              no-body
              class="mb-1"
              :key="`faq-accordion-${index}`"
            >
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button
                  block
                  v-b-toggle="`.accordion-${faq.class}`"
                  variant="carousel-header"
                >
                  <strong class="header" v-html="faq.header"></strong>
                  <span class="acc-toggle">
                    <span class="plus">
                      <svg
                        width="20px"
                        height="20px"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <use href="#icon-plus"></use>
                      </svg>
                    </span>
                    <span class="minus">
                      <svg
                        width="20px"
                        height="20px"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <use href="#icon-minus"></use>
                      </svg>
                    </span>
                  </span>
                </b-button>
              </b-card-header>
              <b-collapse
                :id="`.accordion-${faq.class}`"
                visible
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text>
                    <div class="offset-3 col-9">
                      <ul class="list-unstyled">
                        <li>Bose noise cancelling Headphones 700</li>
                        <li>Audio-only cable (2.5mm to 3.5mm)</li>
                        <li>USB-C to USB-A charging cable (20in./50.8cm)</li>
                        <li>Owner's Manual</li>
                        <li>Protective hard case</li>
                      </ul>
                    </div>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconTogglePlus from "@/components/icons/icon-toggle-plus";
export default {
  name: "blade-faq",
  components: { IconTogglePlus },
  props: ["product", "id", "mainProductImage"],
};
</script>

<style scoped lang="scss">
.container-product-image {
  background: #f3f3f3;
  text-align: center;
  .product-image {
    margin-top: 75px;
    margin-bottom: 50px;
  }
}
.blade-faq {
  padding-top: 90px;
}
.btn-carousel-header {
  text-align: left;
  background: none;
  box-shadow: none;
  border-radius: 0;
}
.card {
  border-left: none;
  border-right: none;
  &:first-of-type {
    border-top: none;
  }
  &-header {
    font-size: 18px;
    text-align: left;
    background: none;
    border: none;
  }
}
.acc-toggle {
  float: right;
  .plus {
    display: none;
  }
}
.collapsed .acc-toggle {
  .plus {
    display: block;
  }
  .minus {
    display: none;
  }
}
li {
  font-size: 16px;
  line-height: 2em;
}
</style>
